export class JsonResponseForGrid {
  list: any[];
  current: any;
  total: any;
}
